import { useAuth } from "@/providers/auth";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function AppStandalone() {
    const { authenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div>Loading</div>;
    }

    if (!authenticated) {
        return <Navigate to="/connexion/sso" state={{ from: location }} replace />;
    }

    return (
        <div className="bg-muted/40">
            <div className="min-h-screen w-screen">
                <Outlet />
            </div>
        </div>
    );
}
